// ////////////////////////////////////////////////////////////
// include needed polyfills
import 'es6-promise/auto';

// ////////////////////////////////////////////////////////////
// picture element shim
import 'script-loader!picturefill';

// ////////////////////////////////////////////////////////////
// polyfill for browsers which don't support xlink:href || href
import svgUseIt from 'svg-use-it';

import { cards } from './lib/card';

document.addEventListener('DOMContentLoaded', () => {
    svgUseIt();
    cards();
});

// ////////////////////////////////////////////////////////////
// check if SVGs are working at all
if (document.createElementNS && document.createElementNS('http://www.w3.org/2000/svg', 'svg').createSVGRect) {
    document.getElementsByTagName('html')[0].setAttribute('class', 'svg');
}

// ////////////////////////////////////////////////////////////
// check if cookies are enabled
let cookieEnabled = (navigator.cookieEnabled) ? true : false;

if (typeof navigator.cookieEnabled == 'undefined' && !cookieEnabled) {
    document.cookie = 'testcookie';
    cookieEnabled = (document.cookie.indexOf('testcookie') != -1) ? true : false;
}

if (!cookieEnabled) {
    document.documentElement.classList.add('no-cookies');
}



// WEBPACK FOOTER //
// ./resources/assets/js/critical.js